import formularioMutation from './formulario.mutations'
import clienteMutation from './cliente.mutation'
import pessoaMutation from './pessoa.mutation'


export default {
    ...formularioMutation,
    ...clienteMutation,
    ...pessoaMutation
}


// WEBPACK FOOTER //
// ./src/store/mutations/index.js